import React from "react"
import { Link } from "gatsby"

// theme  => 'black', 'blue', 'white' 
// varient  => 'primary', 'secondary'

const Button = ({ link, title, variant, theme }) => {
  return  (
      <Link
        to={`${link}`}
        className={`flex items-center justify-center h-[3.125rem] font-normal text-center uppercase border-2 rounded-sm Saira-Bold min-w-[140px] md:min-w-[150px] text-xs md:text-sm tracking-widest 
        ${
          variant === "primary" && theme === "black"
            ? " bg-PrimaryBlack border-black text-TextPrimaryWhite hover:bg-PrimaryHoverBlack hover:border-PrimaryHoverBlack duration-300 ease-in-out"
            : ""
        }${
          variant === "primary" && theme === "blue"
            ? " bg-PrimaryBlue border-ProjectBlue text-TextPrimaryWhite hover:bg-PrimaryHoverBlue hover:border-PrimaryHoverBlue duration-300 ease-in-out"
            : ""
        }${
          variant === "primary" && theme === "white"
            ? "  bg-PrimaryGrey border-grey text-TextPrimaryBlack hover:bg-SecondaryBgCommon hover:text-black duration-300 ease-in-out"
            : ""
        }${
          variant === "secondary" && theme === "white"
            ? " bg-transparent border-grey text-TextPrimaryWhite hover:bg-SecondaryHoverGrey hover:border-grey hover:text-TextPrimaryBlack  duration-300 ease-in-out active:bg-grey active:border-grey active:text-TextPrimaryBlack"
            : ""
        }${
          variant === "secondary" && theme === "blue"
            ? " bg-transparent border-ProjectBlue text-TextPrimaryBlue hover:bg-SecondaryHoverBlue hover:text-grey  duration-300 ease-in-out active:bg-ProjectBlue active:border-ProjectBlue active:text-ProjectBlack"
            : ""
        }${
          variant === "secondary" && theme === "black"
            ? " bg-transparent border-black text-TextPrimaryBlack hover:bg-SecondaryHoverBlack hover:border-black hover:text-grey duration-300 ease-in-out active:bg-black active:border-black active:text-grey"
            : ""
        }`}
      >
        {title}
      </Link>
    ) 

}


export default Button
